export default __webpack_public_path__ + "static/blackberrys-0db390e6bb9d2ccdb8e8ad43b408f3dc.jpg";